module.exports = __webpack_public_path__ + "img/translationeditor_20.4c125c96.jpg";